import { Controller } from "@hotwired/stimulus"

const TYPE_INTERVAL_MS = 34

// Battle-box typewriter and the RUN gag for shared/popups/_bromon: the first
// RUN fails ("can't escape"), the second one closes the dialog.
export default class extends Controller<HTMLDialogElement> {
  static targets = ["card", "typer", "run", "runAgain"]
  static values = { intro: String, escape: String }

  declare readonly cardTarget: HTMLElement
  declare readonly typerTarget: HTMLElement
  declare readonly runTarget: HTMLElement
  declare readonly runAgainTarget: HTMLElement
  declare readonly introValue: string
  declare readonly escapeValue: string
  declare timer?: number
  declare runTries: number

  disconnect() {
    this.stopTyping()
  }

  // Bound after popup#show on the same event, so an open dialog means "this one".
  start() {
    if (!this.element.open) return

    this.reset()
    this.type(this.introValue)
  }

  run() {
    if (this.runTries > 0) {
      this.element.close()
      return
    }

    this.runTries = 1
    this.type(this.escapeValue)
    this.runTarget.hidden = true
    this.runAgainTarget.hidden = false

    // Restart the blocked beat even if it already played once.
    this.cardTarget.classList.remove("promo-bromon--blocked")
    void this.cardTarget.offsetWidth
    this.cardTarget.classList.add("promo-bromon--blocked")
  }

  reset() {
    this.stopTyping()
    this.runTries = 0
    this.runTarget.hidden = false
    this.runAgainTarget.hidden = true
    this.cardTarget.classList.remove("promo-bromon--blocked")
  }

  type(text: string) {
    this.stopTyping()
    let position = 0
    this.typerTarget.textContent = ""
    this.timer = window.setInterval(() => {
      position += 1
      this.typerTarget.textContent = text.slice(0, position)
      if (position >= text.length) this.stopTyping()
    }, TYPE_INTERVAL_MS)
  }

  stopTyping() {
    window.clearInterval(this.timer)
    this.timer = undefined
  }
}
